import Flickity from "flickity";
import "flickity-hash"

const initFeaturesSlider = () => {
    const featuresSlider = document.querySelector('.js-features-slider')

    const navButtons = document.querySelectorAll('.c-hero__bar__col');

    if (featuresSlider) {
        const featuresSliderObj = new Flickity(featuresSlider, {
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            imagesLoaded: true,
            prevNextButtons: false,
            hash: true // Enable hash functionality
        });

        featuresSliderObj.on('change', function(index) {
            // Remove 'is-active' class from all buttons
            navButtons.forEach(function(button) {
                button.classList.remove('is-active');
            });

            // Add 'is-active' class to the current nav button
            navButtons[index].classList.add('is-active');
        });
    }
}

export {initFeaturesSlider}
